/**
 * Settings > Maintenance. Cards render top to bottom in this order; add new
 * maintenance admin cards here (CLAUDE.md §3.6).
 */
import React from 'react';
import RedoOnboardingCard from '../../../../components/admin/RedoOnboardingCard';
import OtpLockoutClearCard from '../../../../components/admin/OtpLockoutClearCard';
import WorkflowRunInspectorCard from '../../../../components/admin/WorkflowRunInspectorCard';
import VectorStoreCard from '../../../../components/admin/VectorStoreCard';
import FrameworkSeedingCard from '../../../../components/admin/FrameworkSeedingCard';
import LifecycleEmailCard from '../../../../components/admin/LifecycleEmailCard';
import Ge2BackfillCard, {
  GE2_DOCUMENT_CHUNKS_BACKFILL,
  GE2_SEMANTIC_MEMORIES_BACKFILL,
} from '../../../../components/admin/Ge2BackfillCard';

export default function MaintenanceSettingsSection() {
  return (
    <>
      {/* Redo onboarding (affects the signed-in super admin only) */}
      <RedoOnboardingCard />

      {/* Clear an email's OTP sign-in lockouts (SEC-32) */}
      <OtpLockoutClearCard />

      {/* Workflow runs: latest list + inspect one by id */}
      <WorkflowRunInspectorCard />

      {/* pgvector store: health check + orphaned chunk cleanup */}
      <VectorStoreCard />

      {/* Framework Seeding */}
      <FrameworkSeedingCard />

      <LifecycleEmailCard />

      {/* GE2 Embedding Backfill — EMBD-05 */}
      <Ge2BackfillCard config={GE2_DOCUMENT_CHUNKS_BACKFILL} />

      {/* GE2 Semantic Memories Backfill — EMIG-03 */}
      <Ge2BackfillCard config={GE2_SEMANTIC_MEMORIES_BACKFILL} />
    </>
  );
}
